import {createPreloadableLazyComponent} from '../../../../util/lazyImport';
import type * as Panel2 from '../panel';
import {defaultFacet, inputType} from './common';

export {defaultFacet} from './common';

export const Spec: Panel2.PanelSpec = {
  id: 'Facet',

  initialize: (weave, inputNode) => defaultFacet(),

  ConfigComponent: createPreloadableLazyComponent(
    () => import('./Component'),
    module => module.PanelFacetConfig
  ).Component,

  Component: createPreloadableLazyComponent(() => import('./Component'))
    .Component,
  inputType,
  hidden: true,
};
